import { actionTypes } from "../actions/MlLicFormContentActions";
import { SortTypes } from "../../util/table-view/TableTypes";
import { defaultResultsPerPage, pagingTotalRelation } from "redux/Types";

const initialState = {
  wizard: { ids: [], copyLive: false, addToEpisodeData: null },
  bulkWizard: { ids: [], usages: {} },
  items: [],
  totalItems: 0,
  totalRelation: pagingTotalRelation.EQUALS,
  selectedItem: {},
  selectedItems: [],
  episodeList: [],
  loading: false,
  loadingMore: false,
  noMore: true,
  posting: { busy: false, message: "", errors: null, action: "" },
  validating: { busy: false },
  editing: null,
  query: {
    order: SortTypes.desc,
    orderBy: "updatedAt",
    page: 0,
    size: defaultResultsPerPage,
    q: "",
    filters: [],
    trackIds: [],
    selectedEpisode: 'all',
    selectedMasterFormId: null,
    clearanceFormId: null,
  },
  errors: null,
  history: {},
  changedFields: [],
  changedTrackFields: [],
  activePreview: 0,
  cfTracks: {},
  cfTracksLoading: false,
  cfAddEpisodesLoading: false,
  cfAddTracksToEpisodesLoading: false,
  tracksPosting: { busy: false, message: "", errors: null },
  trackStates: null,
  openCopyTracksDialog: false,
  copyTracksData: {
    items: [],
    totalItems: 0,
    totalRelation: pagingTotalRelation.EQUALS,
    selectedItem: {},
    selectedItems: [],
    loading: false,
    query: {
      order: SortTypes.desc,
      orderBy: "updatedAt",
      page: 0,
      size: defaultResultsPerPage,
      q: "",
      filters: [],
    },
  },
  triggerFetchEpisodes: false,
  addTrackDialogOpen: false,
  removingEpisode: false,
  removingEpisodeError: "",
  lastRefreshed: 0,
  closeOnRefresh: false,
  refreshBlockingPopup: false,
  notificationIds : { tId : null, clientId: null },
  licInfoDownloading: { busy: false, message: "", errors: null },
  cfInfoDownloading: { busy: false, message: "", errors: null },
  isEditCustomTrack: false,
  editCustomTrackDetails: null,
};

export default function (state = initialState, action) {

  switch (action.type) {
    case actionTypes.ADD_TRACK_DIALOG_OPEN:
      return {
        ...state,
        addTrackDialogOpen: action.payload.open,
        isEditCustomTrack: action.payload.isEditCustomTrack,
        editCustomTrackDetails: action.payload.editCustomTrackDetails,
      };
    case actionTypes.OPENWIZARD:
      return {
        ...state,
        wizard: action.payload,
      };

    case actionTypes.OPEN_BATCHCF_WIZARD:
      return {
        ...state,
        bulkWizard: action.payload,
      };

    case actionTypes.EPISODE_LIST:
      return {
        ...state,
        episodeList: action.payload,
      };
    case actionTypes.CLEAR_TRACKS:
      return {
        ...state,
        items: [],
        totalItems: 0,
        totalRelation: pagingTotalRelation.EQUALS,
        selectedItem: {},
        selectedItems: [],
      };
    case actionTypes.UPDATE_TRACK_METADATA:
      let newTrackDetails = action.payload;
      let tLookup = state.editing.clearance.tLookup || [];
      // let items = state.items || [];
      newTrackDetails.map(t => {
        let index = tLookup.findIndex(v => v.id === t.id);
        // let trackIndex = items.findIndex(v => v.trackDetails.id === t.id);
        if (index === -1) {
          tLookup.push(t);
        }
        // if (trackIndex !== -1) {
        //   items[trackIndex].trackDetails = t;
        // }
      })
      return {
        ...state,
        editing: {
          ...state.editing,
          clearance: {
            ...state.editing.clearance,
            tLookup: tLookup
          }
        },
        // items: items,
      };
    case actionTypes.LOADING:
      return {
        ...state,
        loading: true,
        errors: null,
        selectedItems: [],
        selectedItem: {},
        items: [],
        editing: null,
      };
    case actionTypes.LOAD:
      return {
        ...state,
        loading: false,
        errors: null,
        editing: action.payload.data,
        // items: action.payload.items,
        selectedItems: [],
        selectedItem: (action.payload.items && action.payload.items.length > 0) ? action.payload.items[0] : null,
      };
    case actionTypes.FORMS_LOADING:
      return {
        ...state,
        copyTracksData: {
          ...state.copyTracksData,
          loading: true,
          errors: null,
          selectedItems: [],
          selectedItem: {},
          items: [],
        }
      };
    case actionTypes.FORMS_LOAD:
      return {
        ...state,
        copyTracksData: {
          ...state.copyTracksData,
          loading: false,
          errors: null,
          selectedItems: [],
          selectedItem: (action.payload.items && action.payload.items.length > 0) ? action.payload.items[0] : null,
        }
      };

    case actionTypes.EDITING:
      return {
        ...state,
        editing: action.payload,
      };

    case actionTypes.REFRESH_CF:

      return {
        ...state,
        editing: {
          ...state.editing,
          ...action.payload.data,
        },
        // items: action.payload.items,
      };

    case actionTypes.ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload,
        editing: null,
      };

    case actionTypes.SELECT_ITEMS:
      return {
        ...state,
        selectedItems: action.payload,
      };
    case actionTypes.FOCUS_ITEM:
      return {
        ...state,
        selectedItem: action.payload,
      };

    case actionTypes.REFRESH_ITEMS:


      return {
        ...state,
        items: action.payload,
        selectedItem: state.selectedItem ? action.payload.find(v => v.id === state.selectedItem.id) || action.payload[0] ? action.payload[0] : null : action.payload[0] ? action.payload[0] : null,
        selectedItems: [],
      };
    case actionTypes.POSTING:
      return {
        ...state,
        posting: {
          busy: true,
          message: action.payload.message,
          action: action.payload.action,
          errors: null,
        },
        notificationIds : { 
          ...state.notificationIds,
          tId : action.tId,
        }
      };

    case actionTypes.POST_OK:
      return {
        ...state,
        posting: {
          busy: false,
          message: "",
          action: "",
          errors: null,
        },
        changedFields: [],
        changedTrackFields: [],
        notificationIds : { 
          ...state.notificationIds,
          tId : action.tId,
        }
      };

    case actionTypes.POST_ERROR:
      return {
        ...state,
        posting: {
          busy: false,
          message: "",
          action: "",
          errors: action.payload,
        },
      };
    case actionTypes.REMOVING_EP:
      return {
        ...state,
        removingEpisode: action.payload.removingEpisode,
        removingEpisodeError: action.payload.message,
      };

    case actionTypes.POST_PPL_ERROR:
      return {
        ...state,
        posting: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };

    case actionTypes.SET_TLOOKUP:
      let Oitems = state.items.map(v => {
        if (action.ids?.includes(v.id) && action.payload[v.id]?.prsSearchDateTime) {
          v.prsSearchDateTime = action.payload[v.id]?.prsSearchDateTime || v.prsSearchDateTime;
          v.prsWorkTunecode = action.payload[v.id]?.prsWorkTunecode || v.prsWorkTunecode;
          v.prsWorkPublishers = action.payload[v.id]?.prsWorkPublishers || v.prsWorkPublishers;
          v.prsWorkWriters = action.payload[v.id]?.prsWorkWriters || v.prsWorkWriters;
          v.prsTrack = v.prsTrack && v.prsTrack != null ? v.prsTrack : action.payload[v.id]?.prsTrack || null;
          if (!action.payload[v.id]?.prs) {
            v.prs = action.payload[v.id]?.prs || v.prs;
          }
        }
        return v

      })
      return {
        ...state,
        editing: {
          ...state.editing,
          clearance: { ...state.editing.clearance, tLookup: Object.values(action.payload) }
        },
      };

    case actionTypes.VALIDATING:
      return {
        ...state,
        validating: { busy: true, },
        posting: {
          // busy: true,
          ...state.posting,
          message: action.payload,
          errors: state.posting?.errors ?? null,
        },
      };

    case actionTypes.VALIDATING_OK:
      return {
        ...state,
        validating: { busy: false, },
        posting: {
          // busy: false,
          ...state.posting,
          message: "",
          errors: state.posting?.errors ?? null,
        },
      };

    case actionTypes.VALIDATING_ERROR:
      return {
        ...state,
        validating: { busy: false, },
        posting: {
          // busy: false,
          ...state.posting,
          message: "",
          errors: state.posting?.errors ? { ...state.posting.errors, ...action.payload } : action.payload,
        },
      };

    case actionTypes.CLEAR_ERRORS:
      return {
        ...state,
        posting: {
          // errors: null,
          // errors: action.payload,
          errors: action.payload ? action.payload : null,
        },
      };

    case actionTypes.LOAD_HISTORY:
      if (action.payload.cfId in state.history) {
        state.history[action.payload.cfId][action.payload.trackId] = action.payload.history;
      }
      else {
        state.history[action.payload.cfId] = {};
        state.history[action.payload.cfId][action.payload.trackId] = action.payload.history;
      }
      return {
        ...state
      };

    case actionTypes.REMOVE_HISTORY:
      if (action.payload.cfId in state.history) {
        if (action.payload.trackId in state.history[action.payload.cfId]) {
          delete state.history[action.payload.cfId][action.payload.trackId];
        }
      }
      return {
        ...state
      };

    case actionTypes.REMOVE_HISTORY_ALL:
      if (action.payload.cfId in state.history) {
        delete state.history[action.payload.cfId];
      }
      return {
        ...state
      };

    case actionTypes.PREVIEW_TAB:
      return {
        ...state,
        activePreview: action.payload,
      };

    case actionTypes.LOADING_CFTRACKS:
      return {
        ...state,
        cfTracksLoading: true
      }
    case actionTypes.LOADING_ADDEPISODES:
      return {
        ...state,
        cfAddEpisodesLoading: true
      }
    case actionTypes.LOAD_ADDEPISODES:
      return {
        ...state,
        cfAddEpisodesLoading: false
      }
    case actionTypes.LOADING_ADDTRACKSTOEPISODES:
      return {
        ...state,
        cfAddTracksToEpisodesLoading: true
      }
    case actionTypes.LOAD_ADDTRACKSTOEPISODES:
      return {
        ...state,
        cfAddTracksToEpisodesLoading: false
      }
    case actionTypes.LOAD_CFTRACKS:
      if (action.payload.cfId in state.cfTracks) {
        state.cfTracks[action.payload.cfId][action.payload.trackId] = action.payload.cfTrackData;
      }
      else {
        state.cfTracks[action.payload.cfId] = {};
        state.cfTracks[action.payload.cfId][action.payload.trackId] = action.payload.cfTrackData;
      }
      return {
        ...state,
        cfTracksLoading: false
      };

    case actionTypes.QUERY:
      return {
        ...state,
        query: action.payload,
      };

    case actionTypes.LOADING_TRACKS:
      return {
        ...state,
        tracksPosting: {
          busy: true,
          message: "Loading Tracks..",
          errors: null
        },
        items: [],
        // totalItems: 0
      };

    case actionTypes.LOAD_TRACKS:
      return {
        ...state,
        tracksPosting: {
          busy: false,
          message: "",
          errors: null
        },
        selectedItem: state.selectedItem ? action.payload.items.find(d => d.clearanceFormId === state.selectedItem.clearanceFormId && d.trackDetails.id === state.selectedItem.trackDetails.id) : {},
        items: action.payload.items,
        totalItems: action.payload.totalItems
      };
    case actionTypes.ERROR_TRACKS:
      return {
        ...state,
        tracksPosting: {
          busy: false,
          message: "",
          errors: action.payload
        },
        items: [],
        totalItems: 0
      };
    case actionTypes.UPDATE_TRACK_USAGE:
      return {
        ...state,
        items: state.items.map(v => {
          if (v.id === action.payload.trackId) {
            v.trackUsage = action.payload.trackUsage;
          }
          return v;
        })
      }


    case actionTypes.TRACK_STATES:
      return {
        ...state,
        trackStates: action.payload,
      };

    case actionTypes.TOGGLE_COPY_TRACKS_DIALOG:
      return {
        ...state,
        openCopyTracksDialog: action.payload,
      };
    case actionTypes.ADD_COPIED_TRACKS_TO_FORM:
      return {
        ...state,
        items: state.items.concat(action.payload),
      };
    case actionTypes.TRIGGER_FETCH_EPISODES:
      return {
        ...state,
        triggerFetchEpisodes: !state.triggerFetchEpisodes,
      };
    case actionTypes.UPDATE_PRS_DATA:
      let OListitems = state.items.map(item =>
        item.trackDetails.id == action.id ? { ...item, trackDetails:{...item.trackDetails , prsTrack: action.payload} } : item
      );
      return {
        ...state,
        items: OListitems,
        selectedItem: (OListitems.length > 0) ? OListitems.filter(e => e.trackDetails.id == action.id)[0] : {},
      };

    case actionTypes.LAST_REFRESH:
      return {
        ...state,
        lastRefreshed: action.payload,
      };

    case actionTypes.CLOSE_POPUP_ON_REFRESH:
      return {
        ...state,
        closeOnRefresh: action.payload,
      };

    case actionTypes.BLOCK_REFRESH_POPUP:
      return {
        ...state,
        refreshBlockingPopup: action.payload,
      };

    case actionTypes.NOTIFICATION:
      return {
        ...state,
        notificationIds : { 
          ...state.notificationIds,
          clientId : action.payload,
        }
      };

    case actionTypes.LICINFO_DOWNLOADING:
      return {
        ...state,
        licInfoDownloading: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };
    case actionTypes.LICINFO_DOWNLOADED:
      return {
        ...state,
        licInfoDownloading: {
          busy: false,
          message: "",
          errors: null,
        },
      };
    case actionTypes.LICINFO_DOWNLOAD_ERROR:
      return {
        ...state,
        licInfoDownloading: {
          busy: false,
          message: "",
          errors: action.payload,
        },
      };

    case actionTypes.CLEARANCE_DOWNLOADING:
      return {
        ...state,
        licInfoDownloading: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };
    case actionTypes.CLEARANCE_DOWNLOADED:
      return {
        ...state,
        licInfoDownloading: {
          busy: false,
          message: "",
          errors: null,
        },
      };
    case actionTypes.CLEARANCE_DOWNLOAD_ERROR:
      return {
        ...state,
        licInfoDownloading: {
          busy: false,
          message: "",
          errors: action.payload,
        },
      };
    default:
      return state;
  }
}
